import { connect } from "react-redux";
import { getTrsBenefitPeriodList, getTrsDetail } from "./actions";
import TRS from "./TRS";
const mapStateToProps = ({ trs }) => {
  return { trs };
};
const mapDispatchToProps = {
  getTrsBenefitPeriodList,
  getTrsDetail,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TRS);



// WEBPACK FOOTER //
// ./components/employee/benefits/trs/Container.jsx